import { Link } from "react-router-dom";
import "../App.css";

const page = () => {
  return (
    <div>
      <div className="menu-container">
        <div className="menu">
          <div className="date">Privacy Policy</div>
          <div className="signup"><Link to="/">Home</Link></div>
          <div className="login">{/* Login */}</div>
        </div>
      </div>
      <main className="main-container">
        <div className="policy-main">
          <div className="contact-info">
            <span className="contact-title">INTRODUCTION</span>
            <p className="contact-desc">
              This privacy notice aims to inform you about how we collect and
              process any information that we collect from you, or that you
              provide to us. It covers information that could identify you
              (“personal information”) and information that could not. In the
              context of the law and this notice, “process” means collect,
              store, transfer, use or otherwise act on information. It tells you
              about your privacy rights and how the law protects you. We are
              committed to protecting your privacy and the confidentiality of
              your personal information. Our policy is not just an exercise in
              complying with the law, but a continuation of our respect for you
              and your personal information. We undertake to preserve the
              confidentiality of all information you provide to us, and hope
              that you reciprocate. Except as set out below, we do not share, or
              sell, or disclose to a third party, any information collected
              through our website.
            </p>
            <span className="contact-title">1.DATA WE PROCESS</span>
            <p className="contact-desc">
              We may collect, use, store and transfer different kinds of
              personal data about you. We have collated these into groups as
              follows: Your identity includes information such as first name,
              last name, title, date of birth, and other identifiers that you
              may have provided at some time. Your contact information includes
              information such as billing address, delivery address, email
              address, telephone numbers and any other information you have
              given to us for the purpose of communication or meeting. Your
              financial data includes information such as your bank account and
              payment card details. Transaction data includes details about
              payments or communications to and from you and information about
              products and services you have purchased from us. Technical data
              includes your internet protocol (IP) address, browser type and
              version, time zone setting and location, browser plug-in types and
              versions, operating system and platform and other technology on
              the devices you use to access this website. Marketing data
              includes your preferences in receiving marketing from us;
              communication preferences; responses and actions in relation to
              your use of our services. We may aggregate anonymous data such as
              statistical or demographic data for any purpose. Anonymous data is
              data that does not identify you as an individual. Aggregated data
              may be derived from your personal data but is not considered
              personal information in law because it does not reveal your
              identity. For example, we may aggregate profile data to assess
              interest in a product or service. However, if we combine or
              connect aggregated data with your personal information so that it
              can identify you in any way, we treat the combined data as
              personal information and it will be used in accordance with this
              privacy notice.
            </p>
            <span className="contact-title">
              2.SPECIAL PERSONAL INFORMATION
            </span>
            <p className="contact-desc">
              Special personal information is data about your race or ethnicity,
              religious or philosophical beliefs, sex life, sexual orientation,
              political opinions, trade union membership, information about your
              health and genetic and biometric data. We do not collect any
              special personal information about you.
            </p>
            <span className="contact-title">
              3.IF YOU DO NOT PROVIDE PERSONAL INFORMATION WE NEED
            </span>
            <p className="contact-desc">
              Where we need to collect personal data by law, or under the terms
              of a contract we have with you, and you fail to provide that data
              when requested, we may not be able to perform that contract. In
              that case, we may have to stop providing a service to you. If so,
              we will notify you of this at the time.
            </p>
            <span className="contact-title">
              4.INFORMATION WE PROCESS BECAUSE WE HAVE A CONTRACTUAL OBLIGATION
              WITH YOU
            </span>
            <p className="contact-desc">
              When you create an account on our website, buy a product or
              service from us, or otherwise agree to our terms and conditions, a
              contract is formed between you and us. In order to carry out our
              obligations under that contract we must process the information
              you give us. Some of this information may be personal information.
              We may use it in order to: verify your identity for security
              purposes sell products to you provide you with our services
              provide you with suggestions and advice on products, services and
              how to obtain the most from using our website We process this
              information on the basis there is a contract between us, or that
              you have requested we use the information before we enter into a
              legal contract. We shall continue to process this information
              until the contract between us ends or is terminated by either
              party under the terms of the contract.
            </p>
            <span className="contact-title">
              4.INFORMATION WE PROCESS BECAUSE WE HAVE A CONTRACTUAL OBLIGATION
              WITH YOU
            </span>
            <p className="contact-desc">
              When you create an account on our website, buy a product or
              service from us, or otherwise agree to our terms and conditions, a
              contract is formed between you and us. In order to carry out our
              obligations under that contract we must process the information
              you give us. Some of this information may be personal information.
              We may use it in order to: verify your identity for security
              purposes sell products to you provide you with our services
              provide you with suggestions and advice on products, services and
              how to obtain the most from using our website We process this
              information on the basis there is a contract between us, or that
              you have requested we use the information before we enter into a
              legal contract. We shall continue to process this information
              until the contract between us ends or is terminated by either
              party under the terms of the contract.
            </p>
            <span className="contact-title">
              5.INFORMATION WE PROCESS WITH YOUR CONSENT
            </span>
            <p className="contact-desc">
              Through certain actions when otherwise there is no contractual
              relationship between us, such as when you browse our website or
              ask us to provide you more information about our business, our
              products and services, you provide your consent to us to process
              information that may be personal information. Wherever possible,
              we aim to obtain your explicit consent to process this
              information, for example, by asking you to agree to our use of
              cookies. If you have given us explicit permission to do so, we may
              from time to time pass your name and contact information to
              selected associates whom we consider may provide services or
              products you would find useful. We continue to process your
              information on this basis until you withdraw your consent or it
              can be reasonably assumed that your consent no longer exists. You
              may withdraw your consent at any time by instructing us
              omidabbaspour1020@gmail.com. However, if you do so, you may not be able
              to use our website or our services further.
            </p>
            <span className="contact-title">
              6.INFORMATION WE PROCESS FOR THE PURPOSES OF LEGITIMATE INTERESTS
            </span>
            <p className="contact-desc">
              We may process information on the basis there is a legitimate
              interest, either to you or to us, of doing so. Where we process
              your information on this basis, we do after having given careful
              consideration to: whether the same objective could be achieved
              through other means whether processing (or not processing) might
              cause you harm whether you would expect us to process your data,
              and whether you would, in the round, consider it reasonable to do
              so For example, we may process your data on this basis for the
              purposes of: record-keeping for the proper and necessary
              administration of our bussiness responding to unsolicited
              communication from you to which we believe you would expect a
              response protecting and asserting the legal rights of any party
              insuring against or obtaining professional advice that is required
              to manage organisational risk protecting your interests where we
              believe we have a duty to do so
            </p>
            <span className="contact-title">
              7.INFORMATION WE PROCESS BECAUSE WE HAVE A LEGAL OBLIGATION
            </span>
            <p className="contact-desc">
              Sometimes, we must process your information in order to comply
              with a statutory obligation. For example, we may be required to
              give information to legal authorities if they so request or if
              they have the proper authorisation such as a search warrant or
              court order. This may include your personal information.
            </p>
            <span className="contact-title">
              8.COMPLAINTS REGARDING CONTENT ON OUR WEBSITE
            </span>
            <p className="contact-desc">
              If you complain about any of the content on our website, we shall
              investigate your complaint. If we feel it is justified or if we
              believe the law requires us to do so, we shall remove the content
              while we investigate. Free speech is a fundamental right, so we
              have to make a judgment as to whose right will be obstructed:
              yours, or that of the person who posted the content that offends
              you. If we think your complaint is vexatious or without any basis,
              we shall not
            </p>
            correspond with you about it.
            <span className="contact-title">9.COMMUNICATING WITH US</span>
            <p className="contact-desc">
              When you contact us, whether by telephone, through our website or
              by e-mail, we collect the data you have given to us in order to
              reply with the information you need. We record your request and
              our reply in order to increase the efficiency of our business. We
              keep personally identifiable information associated with your
              message, such as your name and email address so as to be able to
              track our communications with you to provide a high quality
              service.
            </p>
            <span className="contact-title">10.COMPLAINING</span>
            <p className="contact-desc">
              When we receive a complaint, we record all the information you
              have given to us. We use that information to resolve your
              complaint. If your complaint reasonably requires us to contact
              some other person, we may decide to give to that other person some
              of the information contained in your complaint. We do this as
              infrequently as possible, but it is a matter for our sole
              discretion as to whether we do give information, and if we do,
              what that information is. We may also compile statistics showing
              information obtained from this source to assess the level of
              service we provide, but not in a way that could identify you or
              any other person.
            </p>
            <span className="contact-title">
              11.AFFILIATE AND BUSINESS PARTNER INFORMATION
            </span>
            <p className="contact-desc">
              This is information given to us by you in your capacity as an
              affiliate of us or as a business partner. It allows us to
              recognise visitors that you have referred to us, and to credit to
              you commission due for such referrals. It also includes
              information that allows us to transfer commission to you. The
              information is not used for any other purpose. We undertake to
              preserve the confidentiality of the information and of the terms
              of our relationship. We expect any affiliate or partner to agree
              to reciprocate this policy.
            </p>
            <span className="contact-title">12.COOKIES</span>
            <p className="contact-desc">
              Cookies are small text files that are placed on your computer’s
              hard drive by your web browser when you visit any website. They
              allow information gathered on one web page to be stored until it
              is needed for use on another, allowing a website to provide you
              with a personalised experience and the website owner with
              statistics about how you use the website so that it can be
              improved. Some cookies may last for a defined period of time, such
              as one day or until you close your browser. Others last
              indefinitely. Your web browser should allow you to delete any you
              choose. It also should allow you to prevent or limit their use.
              Our website uses cookies. They are placed by software that
              operates on our servers, and by software operated by third parties
              whose services we use. When you first visit our website, we ask
              you whether you wish us to use cookies. If you choose not to
              accept them, we shall not use them for your visit except to record
              that you have not consented to their use for any other purpose. If
              you choose not to use cookies or you prevent their use through
              your browser settings, you will not be able to use all the
              functionality of our website. We use cookies in the following
              ways: to track how you use our website to record whether you have
              seen specific messages we display on our website to keep you
              signed in our site to record your answers to surveys and
              questionnaires on our site while you complete them to record the
              conversation thread during a live chat with our support team
            </p>
            <span className="contact-title">
              13.PERSONAL IDENTIFIERS FROM YOUR BROWSING ACTIVITY
            </span>
            <p className="contact-desc">
              Requests by your web browser to our servers for web pages and
              other content on our website are recorded. We record information
              such as your geographical location, your Internet service provider
              and your IP address. We also record information about the software
              you are using to browse our website, such as the type of computer
              or device and the screen resolution. We use this information in
              aggregate to assess the popularity of the webpages on our website
              and how we perform in providing content to you. If combined with
              other information we know about you from previous visits, the data
              possibly could be used to identify you personally, even if you are
              not signed in to our website.
            </p>
            <span className="contact-title">14.OUR USE OF RE-MARKETING</span>
            <p className="contact-desc">
              Re-marketing involves placing a cookie on your computer when you
              browse our website in order to be able to serve to you an advert
              for our products or services when you visit some other website. We
              may use a third party to provide us with re-marketing services
              from time to time. If so, then if you have consented to our use of
              cookies, you may see advertisements for our products and services
              on other websites.
            </p>
            <span className="contact-title">
              15.INFORMATION WE OBTAIN FROM THIRD PARTIES
            </span>
            <p className="contact-desc">
              Although we do not disclose your personal information to any third
              party (except as set out in this notice), we sometimes receive
              data that is indirectly made up from your personal information
              from third parties whose services we use.
            </p>
            <span className="contact-title">
              16.THIRD PARTY ADVERTISING ON OUR WEBSITE
            </span>
            <p className="contact-desc">
              Third parties may advertise on our website. In doing so, those
              parties, their agents or other companies working for them may use
              technology that automatically collects information about you when
              their advertisement is displayed on our website. They may also use
              other technology such as cookies or JavaScript to personalise the
              content of, and to measure the performance of their adverts. We do
              not have control over these technologies or the data that these
              parties obtain. Accordingly, this privacy notice does not cover
              the information practices of these third parties.
            </p>
            <span className="contact-title">
              17.YOUR DUTY TO INFORM US OF CHANGES
            </span>
            <p className="contact-desc">
              It is important that the personal data we hold about you is
              accurate and current. Please keep us informed if your personal
              data changes.
            </p>
            <span className="contact-title">
              18.REMOVAL OF YOUR INFORMATION
            </span>
            <p className="contact-desc">
              If you wish us to remove personally identifiable information from
              our website, you should contact us to make your request. This may
              limit the service we can provide to you.
            </p>
            <span className="contact-title">
              19.VERIFICATION OF YOUR INFORMATION
            </span>
            <p className="contact-desc">
              When we receive any request to access, edit or delete personal
              identifiable information we shall first take reasonable steps to
              verify your identity before granting you access or otherwise
              taking any action. This is important to safeguard your
              information. 20.ENCRYPTION OF DATA SENT BETWEEN US We use Secure
              Sockets Layer (SSL) certificates to verify our identity to your
              browser and to encrypt any data you give us. Whenever information
              is transferred between us, you can check that it is done so using
              SSL by looking for a closed padlock symbol or other trust mark in
              your browser’s URL bar or toolbar.
            </p>
            <span className="contact-title">21.HOW YOU CAN COMPLAIN</span>
            <p className="contact-desc">
              If you are not happy with our privacy policy or if you have any
              complaint, then you should tell us via our contact us page. If a
              dispute is not settled, then we hope you will agree to attempt to
              resolve it by engaging in good faith with us in a process of
              mediation or arbitration.
            </p>
            <span className="contact-title">
              22.RETENTION PERIOD FOR PERSONAL DATA
            </span>
            <p className="contact-desc">
              Except as otherwise mentioned in this privacy notice, we keep your
              personal information only for as long as required by us: to
              provide you with the services you have requested; to comply with
              other law, including for the period demanded by our tax
              authorities; to support a claim or defence in court.
            </p>
            <span className="contact-title">23.COMPLIANCE WITH THE LAW</span>
            <p className="contact-desc">
              Our privacy policy has been compiled so as to comply with the law
              of every country or legal jurisdiction in which we aim to do
              business. If you think it fails to satisfy the law of your
              jurisdiction, we should like to hear from you. However, ultimately
              it is your choice as to whether you wish to use our website.
            </p>
            <span className="contact-title">
              24.REVIEW OF THIS PRIVACY POLICY
            </span>
            <p className="contact-desc">
              this privacy notice from time to time as necessary. The terms that
              apply to you are those posted here on our website on the day you
              use our website. We advise you to print a copy for your records.
              If you have any question regarding our privacy policy, please
              contact us.
            </p>
          </div>
        </div>
      </main>

      <div className="footer">
        <div className="footer-item footer-one">
          <ul className="footer-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/privacyPolicy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/contactus">Contact Us</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default page;
